function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "ico/x",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M18.25,16 L22,19.75 L19.75,22 L16,18.25 L12.25,22 L10,19.75 L13.75,16 L10,12.25 L12.25,10 L16,13.75 L19.75,10 L22,12.25 L18.25,16 Z",
  id: "Combined-Shape",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/x.c290b8b0.svg";
export { SvgComponent as ReactComponent };